import { render } from "./invoiceRecordModel.vue?vue&type=template&id=41b36666"
import script from "./invoiceRecordModel.vue?vue&type=script&lang=js"
export * from "./invoiceRecordModel.vue?vue&type=script&lang=js"

import "./invoiceRecordModel.vue?vue&type=style&index=0&id=41b36666&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__